export function createFacetState() {
  return {
    options: [],
    selected: [],

    loading: false,
    loadedOnce: false,
    error: false,

    /*
     * Guards against stale asynchronous responses.
     */
    sequence: 0,

    /*
     * Incremented by the UI when the user explicitly retries.
     */
    retryToken: 0,
  };
}

export default function() {
  return {
    items: {},
  };
}
